<template>
  <div class="common-card">
    <remark-list-add-new
      :is-add-new-remark-sidebar-active.sync="isAddNewRemarkSidebarActive"
      :data="remarkData"
      :id="id"
      @refetch-data="refetchData"
    />

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            報價單備註管理
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋報價單備註"
          />
          <b-button
            class="mobile-w100"
            v-if="ability.can('create', 'settings_quotation_description')"
            @click="addRemark"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增備註</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refQuotationDescriptionListTable"
          class="position-relative"
          :items="fetchQuotationDescriptions"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: status -->

          <template #cell(created_at)="data">
            <div class="d-flex">
              {{ getDateTime(data.item.created_at) }}
            </div>
          </template>

          <template #cell(updated_at)="data">
            <div class="d-flex">
              {{ getDateTime(data.item.updated_at) }}
            </div>
          </template>



          <template #cell(is_active)="data">
            <feather-icon
              v-if="data.item.is_active"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>


          <!-- Column: content -->
          <template #cell(description)="data">
            <div v-html="data.item.description"></div>
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                quotationDescriptionsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('update', 'settings_quotation_description')"
                @click="editRemark(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'settings_quotation_description')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useQuotationDescriptionsList from "./useQuotationDescriptionsList.js";
import quotationDescriptionStoreModule from "../quotationDescriptionStoreModule";
import RemarkListAddNew from "./RemarkListAddNew.vue";
// import ModalTemplateFilter from "../modal/ModalTemplateFilter.vue";

export default {
  components: {
    // ModalTemplateFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    RemarkListAddNew,
  },
  data() {
    return {
      isAddNewRemarkSidebarActive: false,
      // remarkData: null,
      id: 0,
    };
  },
  methods: {
    addRemark() {
      this.id = 0;
      this.remarkData = {
        id: 0,
        title: "",
        content: 0,
        is_active: 1,
        sort_order: 1,
      };
      this.isAddNewRemarkSidebarActive = true;
    },
    editRemark(item) {
      this.id = item.id;
      this.remarkData = {...item};
      console.log(this.remarkData)
      this.isAddNewRemarkSidebarActive = true;
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("quotation-description/deleteQuotationDescription", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "quotation-description";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, quotationDescriptionStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });


    const {
      fetchQuotationDescriptions,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      quotationDescriptionsList,
      refQuotationDescriptionListTable,
      ability,
      refetchData,
    } = useQuotationDescriptionsList();

    return {
      fetchQuotationDescriptions,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      quotationDescriptionsList,
      refQuotationDescriptionListTable,
      ability,
      refetchData,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    